import { TableCard } from "@ui/internal/components/card";
import { endpoint } from "@services/api.services";
import { useHandleAction } from "@utils/hook/index.hook";
import { QueryData } from "@utils/interface/index.interface";
import { useListData } from "@utils/query/index.query";
import { RedirectData } from "@utils/interface/journey.interface";
import { ColumnList } from "./column/index.column";
import RedirectForm from "./form/index.form";

const Redirects = () => {
  const { searchParams } = useHandleAction({});

  const {
    data: fetchData,
    isLoading: fetchPending,
    refetch,
  } = useListData<QueryData<RedirectData>>({
    endpoint: endpoint.redirect,
    params: {
      p: searchParams.get("tpage") || 1,
      page_size: searchParams.get("per") || 10,
      search: searchParams.get("search") || "",
    },
    key: "redirects-listing",
  });

  const columns = ColumnList({ refetch });

  const rows = Array.isArray(fetchData?.data)
    ? fetchData.data
    : fetchData?.data?.results || [];

  // @ts-ignore
  const count = fetchData?.total_count || fetchData?.data?.total_count || fetchData?.data?.count || rows.length;

  return (
    <TableCard
      table_content={{
        mode: "default",
        type: "redirects",
      }}
      columns={columns}
      rows={rows}
      count={count}
      isPending={fetchPending}
      endpoint={endpoint.redirect}
      refetch={refetch}
      form={<RedirectForm refetch={refetch} />}
    />
  );
};

export default Redirects;
